import React, { forwardRef, useEffect } from 'react';

import { INotes } from '../../../types/INotes';

import Icon from '../../../../ui/icon/icon';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Link } from 'react-router-dom';

const Notes = forwardRef<HTMLDivElement, INotes>(({
                                                    notes,
                                                    name,
                                                    currencyName,
                                                    currencySymbol,
                                                    notesShown,
                                                    toggleNotes,
                                                    currencySelection,
                                                    handleCurrencyChange,
                                                    selectedCurrency,
                                                    selectedObject,
                                                    homePage,
                                                    localCurr,
                                                    widget,
                                                    investorId,
                                                    type,
                                                  }, ref) => {
  return (
    <div className='notes'>
      {homePage ? <Link to={`/boards/${investorId}/${widget.contentId}`} state={{ data: selectedObject.objectPath }}
                        className='widget-link-title'>{name}</Link> : <p>{name}</p>}
      {!currencySelection ? <p className='currency-span'>{currencySymbol}{currencyName}</p> :
        <DropDownList
          data={currencySelection}
          value={selectedCurrency}
          onChange={handleCurrencyChange}
          textField={'currencyShortName'}
          dataItemKey={'currency'} />
      }
      {type === 'summary' &&
        //@ts-ignore
        selectedCurrency.currency === '_' &&
        <p className='local-currency-span'>{localCurr}</p>
      }
      {notes && notes.length > 0 && (
        <div className='notes-wrapper'>
          <Icon name={`${notesShown ? 'far' : 'fas'} fa-circle-info`} className='notes-info' onClick={toggleNotes}
                id={'notes-widget-icon'} />
          {notesShown && (
            <div className='notes-content' ref={ref}>
              {notes.map((note, key) => (
                <p key={key}>
                  {note.symbol} {note.note}
                </p>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
});

export default Notes;
